import React, { useEffect, useState } from 'react';
import "../../styles/LiveEvents.css";
import EventCard from '../cards/EventCard';
import { getEvents } from '../../api/contentApi';
import ApiContentState from '../common/ApiContentState';

export default function LiveEvents() {
  const [apiEvents, setApiEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [loadError, setLoadError] = useState("");

  useEffect(() => {
    getEvents()
      .then((items) => setApiEvents(Array.isArray(items) ? items.map((event) => {
        const eventDate = event.createdAt ? new Date(event.createdAt) : new Date();
        return {
          id: event.id,
          date: String(eventDate.getDate()).padStart(2, '0'),
          month: eventDate.toLocaleString('en-US', { month: 'short' }).toUpperCase(),
          title: event.title,
          time: event.time || '7:00 PM IST',
          themeColor: event.theme === 'pink' ? '#E1306C' : event.theme === 'gold' ? '#D99A00' : '#0052FF',
          ctaLink: '#login',
          iconLayout: <div className="mock-3d-wrapper yt-perspective"><div className="yt-back-device"><div className="yt-screen-play-btn">▶</div></div></div>,
        };
      }) : []))
      .catch((error) => {
        console.error('Unable to load live events:', error);
        setLoadError("Unable to load live events.");
      })
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <section className="homepage-section">
      <div className="live-events-max-container">
        
        <div className="live-events-header-row">
          <div className="live-events-titles-group">
            <span className="live-events-top-pill-label">UPCOMING LIVE EVENTS</span>
            <h2 className="live-events-headline-text">Don't Miss Our <span>Live Events</span></h2>
          </div>
          <a href="#all-events" className="live-events-view-all-desktop-link">
            View All Events ➔
          </a>
        </div>

        <div className="live-events-cards-viewport-grid">
          {isLoading || loadError || apiEvents.length === 0 ? (
            <ApiContentState
              loading={isLoading}
              error={loadError}
              emptyMessage="No live events are scheduled right now."
            />
          ) : apiEvents.map((event) => (
            <EventCard key={event.id} eventData={event} />
          ))}
        </div>

        <div className="live-events-mobile-link-wrapper">
          <a href="#all-events" className="live-events-view-all-mobile-link">
            View All Events ➔
          </a>
        </div>

      </div>
    </section>
  );
}